import { Button } from "@/components/ui/button";
import {
	Menubar,
	MenubarContent,
	MenubarItem,
	MenubarMenu,
	MenubarPortal,
	MenubarSub,
	MenubarSubContent,
	MenubarSubTrigger,
	MenubarTrigger,
} from "@/components/ui/menubar";
import type { StockScannerEventOption } from "@/components/widgets/Markets/types";
import { EVENTS } from "@/shared/eventEmiters/consts";
import type { EventEmitter } from "@/shared/eventEmiters/EventEmitter";
import { screenerPresetsFiltered } from "../../../screenerPresets";

export const ScreenerPresetDropdown = ({
	eventEmitter,
}: {
	eventEmitter?: EventEmitter;
}) => {
	const handlePresetSelect = (option: StockScannerEventOption) => {
		const { sort, fields, filter } = option;

		const newState = { sort, fields, filter };
		eventEmitter?.emit(EVENTS.WIDGET_STATE, newState);
	};

	return (
		<Menubar data-testid="screener-preset-dropdown">
			<MenubarMenu>
				<MenubarTrigger asChild>
					<Button
						variant="dropdown"
						className=" text-gold h-fit p-0 font-bold cursor-pointer"
					>
						Preset
					</Button>
				</MenubarTrigger>

				<MenubarPortal>
					<MenubarContent data-testid="screener-preset-dropdown-content">
						{screenerPresetsFiltered.map((preset) => (
							<MenubarSub key={preset.presetName}>
								<div className="border-l border-light-gray ml-0.5">
									<MenubarSubTrigger>{preset.presetName}</MenubarSubTrigger>

									<MenubarPortal>
										{preset?.options?.length && (
											<MenubarSubContent className="ml-2">
												<div className="border-l border-light-gray ml-0.5">
													{preset?.options?.map((option) => (
														<MenubarItem
															onClick={() => handlePresetSelect(option)}
															key={option.label}
														>
															{option.label}
														</MenubarItem>
													))}
												</div>
											</MenubarSubContent>
										)}
									</MenubarPortal>
								</div>
							</MenubarSub>
						))}
					</MenubarContent>
				</MenubarPortal>
			</MenubarMenu>
		</Menubar>
	);
};
